export enum TicketType {
  GENERAL_DISCUSSION = 'GENERAL_DISCUSSION',
  CUSTOMER_INSURANCE_REQUEST = 'CUSTOMER_INSURANCE_REQUEST',
  INSURANCE_MANDATE_REQUEST = 'INSURANCE_MANDATE_REQUEST',
}
